<template>
  <div class="mains">
    <div class="campus">
      教材管理
      <span>></span>自制教材区
    </div>
    <div class="xiaoqu moerduo">
      <el-card :span="24">
        <div class="grid-content bg-purple scrollbarStyle test-2">
          <el-dialog title="新建文件夹" :visible.sync="addBookGroups">
            <div class="form_1 form_1_1">
              <el-form ref="forms" :model="forms" :rules="FormRules" label-width="5.20833vw">
                <el-form-item label="文件夹名称" prop="name" class="wjj_mc">
                  <i>
                    <img src="@/assets/img/education-manage/campus/bitian.png" style="left: -5vw; top: 0.78125vw" class="wuzi" />
                  </i>
                  <el-input v-model="forms.name" placeholder="请输入文件夹名称"></el-input>
                </el-form-item>
                <el-form-item class="queding">
                  <el-button type="primary" @click="addBookGroup">
                    确定
                  </el-button>
                  <el-button @click="quxiao">取消</el-button>
                </el-form-item>
              </el-form>
            </div>
          </el-dialog>

          <div class="xiaoqu_1">自制教材区</div>
          <el-button type="primary" class="buttons xj_wjj zz_tianjia" @click="selfbookadd">
            <!-- <span>
              <img src="@/assets/img/textbook-manage/schoolbook/tianjia.png" />
            </span> -->
            添加自制教材
          </el-button>
          <!--
          <el-button
            type="primary"
            style="width: 5.72917vw"
            class="buttons xj_wjj"
            @click="addBookGroup1"
          >
            <span>+</span>
            新建文件夹
          </el-button>
          -->
          <div class="sousuo sousuo_wjj">
            <span>教材名称：</span>
            <el-input v-model="orgnames" @keyup.13.native="getBookList" placeholder="请输入教材关键字进行查找"></el-input>
            <el-button type="primary" class="buttons sousuo_wjj1" @click="getBookList()">查 询</el-button>
          </div>
        </div>
      </el-card>
      <el-row :gutter="24" class="zj_jc">
        <el-col :span="5">
          <div class="grid-content bg-purple scrollbarStyle" style="height: 71vh; overflow: auto">
            <div class="zz_jcfl">
              <div class="jcfl">教材分类</div>

              <el-menu default-active="3" class="el-menu-vertical-demo kb_bc" :unique-opened="true" :default-openeds="['1']">
                <el-submenu v-for="(item, index) in jiaocai_List" :key="index" :index="item.strId">
                  <template slot="title">
                    <span>{{ item.name }}</span>
                  </template>
                  <el-menu-item v-for="(sub, index) in item.submenus" :key="index" :index="sub.strId" @click="bc_fb(sub.strId)">
                    {{ sub.name }}
                  </el-menu-item>
                </el-submenu>
              </el-menu>
              <div class="jc_kj_tu">
                <img src="@/assets/img/textbook-manage/schoolbook/zzjc.png" alt="" />
              </div>
            </div>
          </div>
        </el-col>

        <el-col :span="18" class="zz_18">
          <div class="grid-content bg-purple scrollbarStyle" style="height: 71vh; overflow: auto">
            <div class="zz_jc">教材</div>
            <div class="jiaocai_1 jiaocai_1s jiao_tu zz_jiao_tu dz-flex dz-flex-wrap">
              <div class="jiaocai" v-for="(item, index) in jiaoyu1" :key="index" @click="tiaozhuan(item)">
                <div class="jiaocai_tu">
                  <img :src="item.zuoshangjiao" class="zuoshangjiao" alt="" />

                  <span class="yinying">
                    <span class="yinying_zi">{{ item.name }}</span>
                    <img :src="item.picurl" style="border-radius: 0.52083vw" alt="" />
                  </span>
                  <img :src="item.youxiajiao" style="float: right" class="youxiajiao" :class="item.youxiajiao ? '' : 'youxiajiao2'" alt="" />
                </div>
                <div class="jiaocai_zi">{{ item.shortname }}</div>
              </div>

              <div class="function_zong ml-50">
                共<span> {{ total }} </span>本教材，当前页面显示<span>
                  {{ jczongshu0 }}
                </span>
                本
              </div>
              <el-pagination class="fenye_1" background @size-change="handleSizeChange" @current-change="handleCurrentChange" :current-page="currentPage" :page-size="pageSize" layout="prev, pager, next, jumper"
                :total="total">
              </el-pagination>
            </div>
          </div>
        </el-col>
      </el-row>
    </div>
  </div>
</template>

<script>
export default {
  name: 'selfbook',
  data() {
    return {
      FormRules: {},
      jiaocai_List: [
        {
          name: '自制课本',
          strId: '1',
          submenus: [
            {
              name: '已保存',
              strId: '3',
            },
            {
              name: '已发布',
              strId: '4',
            },
          ],
        },
        {
          name: '自制课件',
          strId: '2',
          submenus: [
            {
              name: '已保存',
              strId: '5',
            },
            {
              name: '已发布',
              strId: '6',
            },
          ],
        },
      ],
      jiaoyu1: [],
      orgnames: '',
      type: 1,
      status: '',
      page: 1,
      currentPage: 1,
      pageSize: 10,
      total: 0,
      addBookGroups: false,
      forms: {
        name: '',
      },
      jczongshu0: '',
    };
  },
  watch: {
    addBookGroups() {
      if (this.addBookGroups === false) {
        this.forms.name = '';
      }
    },
  },
  created() {
    this.getBookList();
  },
  methods: {
    tiaozhuan(item) {
      if (item.status !== 0) {
        // return this.$message({
        //   message: '该教材已上架，不可修改！',
        //   type: 'warning'
        // })
        return this.$message.warning('该教材已上架，不可修改！');
      }
      let addbookId = item.id;
      this.$store.commit('addbookId', addbookId);
      this.$router.push({
        path: '/addBook',
      });
    },

    selfbookadd() {
      this.$router.push({
        path: '/selfbookadd',
      });
    },

    bc_fb(id) {
      if (id === '3') {
        this.status = '';
      } else if (id === '4') {
        this.status = 1;
      }
      this.getBookList();
    },

    // 添加文件夹
    addBookGroup1() {
      this.addBookGroups = true;
    },
    addBookGroup() {
      let token = window.sessionStorage.getItem('userinfo').replace(/"/g, '');
      let orgid = window.sessionStorage.getItem('orgid');
      let pro = this.$http({
        url: '/edu/bookgroup/addBookGroup',
        method: 'POST',
        data: {
          name: this.forms.name,
          orgid: orgid,
          picurl: 'http://',
          type: 0,
        },
        headers: {
          Authorization: 'Bearer ' + token,
        },
      });
      pro
        .then((result) => {
          // console.log(result)
          if (result.data.code !== 0) {
            return this.$message.error(result.data.message);
          }
          if (this.forms.name === '') {
            return this.$message.error('请先输入文件夹名称！');
          } else {
            this.addBookGroups = false;
            this.getBookList();
            return this.$message.success('新建文件夹完成!');
          }
        })
        .catch((err) => {
          // console.log(err)
          return this.$message.error('新建文件夹失败：' + err);
        });
    },
    quxiao() {
      if (this.addBookGroups) {
        this.addBookGroups = false;
      }
    },

    // 查询自制教材
    getBookList() {
      let token = window.sessionStorage.getItem('userinfo').replace(/"/g, '');
      let orgid = window.sessionStorage.getItem('orgid');
      let pro = this.$http({
        url: '/edu/book/getBookList',
        method: 'POST',
        data: {
          orgid: orgid,
          type: this.type,
          name: this.orgnames,
          status: this.status,
          page: this.page,
          pageSize: this.pageSize,
        },
        headers: {
          Authorization: 'Bearer ' + token,
        },
      });
      pro
        .then((result) => {
          console.log(result);
          if (result.data.code !== 0) {
            return this.$message.error(result.data.message);
          }
          this.jiaoyu1 = result.data.data;
          this.jczongshu0 = result.data.data.length;
          this.jiaoyu1.forEach(function (c) {
            c.zuoshangjiao = require('@/assets/img/textbook-manage/schoolbook/zizhi1.png');
            c.youxiajiao = require('@/assets/img/textbook-manage/schoolbook/zizhi.png');
            c.xuanzhong1 = false;
          });
          if (this.jiaoyu1 === undefined || this.jiaoyu1 === null) {
            this.total = 0;
          } else {
            this.total = result.data.size;
            // console.log(result.data.size)
          }
        })
        .catch((err) => {
          // console.log(err)
          return this.$message.error('查询自制教材失败：' + err);
        });
    },
    handleSizeChange(val) {
      this.pageSize = val;
      this.page = 1;
      this.currentPage = 1;
      this.getBookList();
    },
    handleCurrentChange(val) {
      this.page = val;
      this.getBookList();
    },
  },
};
</script>

<style lang="less">
.zz_tianjia {
  width: 127px !important;
  line-height: 33px;
  img {
    float: left;
    margin: 8px 0 0 10px;
    width: 16px;
    height: 17px;
  }
}

.test-2 {
  margin-bottom: 23px;
}
.zj_jc {
  margin-top: 15px;
  .el-col-5 {
    width: 390px !important;
  }

  .zz_jcfl {
    padding: 30px 0 0 53px;
    .jcfl {
      font-size: 20px;
      color: #333;
      font-weight: bold;
      margin-bottom: 25px;
    }
    .el-submenu {
      margin-left: -53px;
      .el-submenu__title {
        font-size: 18px;
        padding: 0 !important;
        background: #f2f2f2;
        border-radius: 5px;
        span {
          padding-left: 53px;
        }
      }
      .el-menu-item {
        // margin-left: -53px;
        // font-size: 18px;
        color: #999999;

        padding-left: 53px !important;
        background: #fff !important;
      }
      .el-submenu__title:hover {
        color: #fff;
        background: #00a6e6;
        .el-icon-arrow-down:before {
          color: #fff;
        }
      }
      .el-menu-item:hover {
        color: #00a6e6;
      }

      .el-menu-item.is-active {
        color: #00a6e6;
      }
    }
    .is-opened {
      .el-submenu__title {
        color: #fff !important;
        background: #00a6e6;
      }
      .el-icon-arrow-down:before {
        color: #fff;
      }
    }

    .kb_bc {
      width: 263px;
      height: 50px;
      line-height: 50px;

      .el-submenu__title {
        color: #999999;
      }
    }
    .el-menu {
      border: none;
    }

    .jc_kj_tu {
      width: 382px;
      position: absolute;
      bottom: 40px;
      margin-left: -94px;
      img {
        width: 100%;
        height: 100%;
      }
    }
  }

  .zz_18 {
    width: 1300px;
    padding: 0 0 0 3px !important;
    .zz_jc {
      margin: 20px 0 0 68px;
      color: #333;
      font-size: 18px;
    }
    .zz_jiao_tu {
      margin-left: 19px !important;
    }
    .fenye_1 {
      margin-bottom: 0;
    }
    .jiaocai_1s .jiaocai {
      margin-left: 60px !important;
    }
  }
}
</style>
